import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "nr-datepicker field" }
const _hoisted_2 = { class: "field is-grouped" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = ["placeholder", "name", "aria-labelledby", "id", "value", "disabled"]
const _hoisted_5 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrDatepickerCalendar = _resolveComponent("NrDatepickerCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NrFormLabel, {
      class: _normalizeClass(['nr-label', { 'is-sr-only': _ctx.hideLabel }]),
      id: `${_ctx.id}__label`,
      for: _ctx.id
    }, {
      default: _withCtx(() => [
        (_ctx.required)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("*")
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode("NextRequest datepicker")
        ])
      ]),
      _: 3
    }, 8, ["class", "id", "for"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          "aria-autocomplete": "none",
          type: "text",
          placeholder: _ctx.placeholder,
          name: _ctx.name,
          "aria-labelledby": `${_ctx.id}__label`,
          class: _normalizeClass(_ctx.inputClassnames),
          id: _ctx.id,
          value: _ctx.formattedDate,
          disabled: _ctx.disabled,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
          onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handeInputKeypress && _ctx.handeInputKeypress(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
        }, null, 42, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NrIconButton, {
          ref: "trigger",
          onClick: _ctx.toggleShow,
          variant: "bordered-neutral",
          size: "large",
          icon: { name: 'calendar-alt', type: 'regular' },
          "aria-label": `Select a date, currently selected date is ${new Date(
            _ctx.formattedDate
          ).toDateString()}`,
          disabled: _ctx.disabled
        }, null, 8, ["onClick", "aria-label", "disabled"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, name) => {
      return (_openBlock(), _createElementBlock("p", {
        key: name,
        class: "help is-danger"
      }, _toDisplayString(error), 1))
    }), 128)),
    _withDirectives(_createVNode(_component_NrDatepickerCalendar, {
      onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleShow(false))),
      onSelected: _ctx.handleSelect,
      date: _ctx.convertStringToDate(_ctx.formattedDate),
      minDate: _ctx.computedMinDate,
      maxDate: _ctx.computedMaxDate,
      unselectables: _ctx.computedUnselectableDates,
      style: _normalizeStyle(_ctx.calendarStyles),
      ref: "calendar"
    }, null, 8, ["onSelected", "date", "minDate", "maxDate", "unselectables", "style"]), [
      [_vShow, _ctx.isVisibile]
    ])
  ]))
}